import type { ReactNode } from 'react';

export const symbol_system_update_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h220q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140v520h680v-520H600q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h220q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm310-301v-309q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v309l106-106q9-9 21-8.5t21 9.5q9 9 9 21.5t-9 21.5L501-366q-9 9-21 9t-21-9L301-524q-9-9-8.5-21.5T302-567q9-9 21.5-9t21.5 9l105 106Z"
		/>
	</svg>
);
